export enum ListType {
    POPUP = "popup",
    PERSISTENT = "persistent"
}
